import { render, staticRenderFns } from "./TargetingProperties.vue?vue&type=template&id=c4e832f4"
import script from "./TargetingProperties.vue?vue&type=script&lang=js"
export * from "./TargetingProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports